 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import E9781466821378_COV01 from '@/components/e9781466821378_cov01'
 import E9781466821378_TP01 from '@/components/e9781466821378_tp01'
 import E9781466821378_TOC01 from '@/components/e9781466821378_toc01'
 import E9781466821378_DED01 from '@/components/e9781466821378_ded01'
 import E9781466821378_ACK01 from '@/components/e9781466821378_ack01'
 import E9781466821378_FM04 from '@/components/e9781466821378_fm04'
 import E9781466821378_FM03 from '@/components/e9781466821378_fm03'
 import E9781466821378_FM01 from '@/components/e9781466821378_fm01'
 import E9781466821378_EPI01 from '@/components/e9781466821378_epi01'
 import E9781466821378_FM02 from '@/components/e9781466821378_fm02'
 import E9781466821378_C01 from '@/components/e9781466821378_c01'
 import E9781466821378_C02 from '@/components/e9781466821378_c02'
 import E9781466821378_C03 from '@/components/e9781466821378_c03'
 import E9781466821378_C04 from '@/components/e9781466821378_c04'
 import E9781466821378_C05 from '@/components/e9781466821378_c05'
 import E9781466821378_C06 from '@/components/e9781466821378_c06'
 import E9781466821378_C07 from '@/components/e9781466821378_c07'
 import E9781466821378_BM01 from '@/components/e9781466821378_bm01'
 import E9781466821378_BM02 from '@/components/e9781466821378_bm02'
 import E9781466821378_ATA01 from '@/components/e9781466821378_ata01'
 import E9781466821378_ALS01 from '@/components/e9781466821378_als01'
 import E9781466821378_BM03 from '@/components/e9781466821378_bm03'
 import E9781466821378_COP01 from '@/components/e9781466821378_cop01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9781466821378_toc01",
 			"name" : "e9781466821378_toc01",
 			"component" : E9781466821378_TOC01
 		},
 		{
 			"path" : "/e9781466821378_ded01",
 			"name" : "e9781466821378_ded01",
 			"component" : E9781466821378_DED01
 		},
 		{
 			"path" : "/e9781466821378_ack01",
 			"name" : "e9781466821378_ack01",
 			"component" : E9781466821378_ACK01
 		},
 		{
 			"path" : "/e9781466821378_fm04",
 			"name" : "e9781466821378_fm04",
 			"component" : E9781466821378_FM04
 		},
 		{
 			"path" : "/e9781466821378_fm03",
 			"name" : "e9781466821378_fm03",
 			"component" : E9781466821378_FM03
 		},
 		{
 			"path" : "/e9781466821378_fm01",
 			"name" : "e9781466821378_fm01",
 			"component" : E9781466821378_FM01
 		},
 		{
 			"path" : "/e9781466821378_epi01",
 			"name" : "e9781466821378_epi01",
 			"component" : E9781466821378_EPI01
 		},
 		{
 			"path" : "/e9781466821378_fm02",
 			"name" : "e9781466821378_fm02",
 			"component" : E9781466821378_FM02
 		},
 		{
 			"path" : "/e9781466821378_c01",
 			"name" : "e9781466821378_c01",
 			"component" : E9781466821378_C01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js